// CPP and PATIENT_ASSISTANCE
export const SET_PATIENT_ACTIVE_CPP_TASKS = 'TaskTaskGlobalContext.SET_PATIENT_ACTIVE_CPP_TASKS';
export const SET_PATIENT_ALL_CPP_TASKS = 'TaskGlobalContext.SET_PATIENT_ALL_CPP_TASKS';
export const UPDATE_WEEKLY_TASKS = 'TaskGlobalContext.UPDATE_WEEKLY_TASKS';
export const SET_WEEKLY_TASKS = 'TaskGlobalContext.SET_WEEKLY_TASKS';